var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{staticClass:"spinner"},[_c('vue-spinner',{attrs:{"size":"50","line-size":17,"text-fg-color":"#aa00ff","line-fg-color":"#aa00ff","message":"Loading Please wait!"}})],1):_c('div',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }